module.exports = __webpack_public_path__ + "img/cloud-rain-sun.5b8eaf04.svg";